import React from 'react';
import { useTranslation } from 'react-i18next';
import helpers from '../../Utils/helpers'
import UserSearchNew from '../Search/UserSearchNew'
import Loader from '../Loader'
import LeadTrials from './LeadTrials';
import customerRoutes from "../../Constants/Customer/customerRoutes";
import { FormInput } from "../FormComponents/Input/Input";
import {FormSearchNew} from "../Search/FormSearch";
import CustomerSearch from "../Search/CustomerSearch";

function LeadForm ({lead, onFieldChange, onSaveClick, onCancelClick, readonly, onCloseClick}) {
    const {t} = useTranslation();

    const customerSearchOnChangeNew = (customer) => {
        onFieldChange('customerNumber', customer.customerNumber);
        onFieldChange('name', customer.name);
    }

    if (!lead) {
        return null;
    }

    const phoneNumber = readonly ? helpers.formatPhoneNumberForCountry(lead.phoneNumber) : lead.phoneNumber;
    
    return <>
        <form className="skynet-form">
            {!readonly && <>
                <FormSearchNew label={t('leadform.searchcustomer')}>
                    <CustomerSearch id={'myLeadDetailsSearch'} onChange={customerSearchOnChangeNew}/>
                </FormSearchNew>
                <h3>{t('leadform.contactinformation')}</h3>
                <FormInput label={t('leadform.phone')} copyToClipBoard={true}
                           onChange={onFieldChange.bind(this, 'phoneNumber')} value={phoneNumber} readonly={readonly}/>
                <FormInput label={t('leadform.email')} copyToClipBoard={true}
                           onChange={onFieldChange.bind(this, 'email')} value={lead.email} type="email"
                           readonly={readonly}/>

                <FormInput label={t('leadform.name')} value={lead.name} readOnly={true}/>
                <FormInput label={t('leadform.custno')} value={lead.customerNumber ? lead.customerNumber : 'N/A'}
                                 type={lead.customerNumber && lead.customerNumber !== 'N/A' ? 'link' : ''}
                                 link={customerRoutes.customer(lead.customerNumber)} readOnly={true}/>
                <FormInput label={t('leadform.organizationnumber')}
                           onChange={onFieldChange.bind(this, 'organizationNumber')}
                           value={lead.organizationNumber}
                           readonly={readonly}/>
                <FormInput label={t('leadform.type')} value={lead.companyType} readOnly={true}/>
                <FormInput label={t('leadform.contact')} onChange={onFieldChange.bind(this, 'contact')}
                           value={lead.contact} readonly={readonly}/>
                <br/>
                <h3>{t('leadform.leadinformation')}</h3>
                <FormSearchNew label={t('leadform.assignedto')}>
                    <UserSearchNew onChange={(user) => onFieldChange('assignee', user.email || '')}
                                 defaultSelected={lead.assignee} />
                </FormSearchNew>
                <FormInput label={t('leadform.type')} value={lead.type} readOnly={true}/>
                <FormInput label={t('leadform.product')} value={lead.productNumber} readOnly={true}/>
                <FormInput label={t('leadform.created')} value={helpers.formatDate(lead.dateCreated)} readOnly={true}/>
                <FormInput label={t('leadform.submitted')} value={helpers.formatDate(lead.dateSubmitted)} readOnly={true}/>
                <br/>
                <div className="form-group">
                    <button type="button" className="btn btn-primary"
                            onClick={onSaveClick.bind(this)}>{t('leadform.save')}</button>
                    <button type="button" className="btn btn-default" onClick={onCancelClick.bind(this)}><span
                        className="vismaicon vismaicon-sm vismaicon-undo"></span>{t('leadform.cancel')}</button>
                    <Loader/>
                </div>
            </>}
            {readonly && <div className="row">
                <div className="col-sm-6 col-12">
                    <FormInput label={t('leadform.phone')} copyToClipBoard={true} readOnly={true}
                                    onChange={onFieldChange.bind(this, 'phoneNumber')} value={phoneNumber}/>
                    <FormInput label={t('leadform.name')} value={lead.name} readOnly={true} />
                    <FormInput label={t('leadform.organizationnumber')} readOnly={true}
                                    onChange={onFieldChange.bind(this, 'organizationNumber')}
                                    value={!lead.organizationNumber && readonly ? 'N/A' : lead.organizationNumber}/>
                    <FormInput label={t('leadform.contact')} onChange={onFieldChange.bind(this, 'contact')}
                                    value={lead.contact} readOnly={true}/>
                    <FormInput label={t('leadform.type')} value={lead.type} readOnly={true}/>
                    <FormInput label={t('leadform.created')} value={helpers.formatDate(lead.dateCreated)} readOnly={true}/>
                    <FormInput label={t('leadform.status')} value={lead.status} readOnly={true}/>
                </div>
                <div className="col-sm-6 col-12">
                    <FormInput label={t('leadform.email')} copyToClipBoard={true} readOnly={true}
                               onChange={onFieldChange.bind(this, 'email')} value={lead.email} type="email"/>
                    <FormInput label={t('leadform.custno')} readOnly={true}
                               value={lead.customerNumber ? lead.customerNumber : 'N/A'}
                               type={lead.customerNumber && lead.customerNumber !== 'N/A' ? 'link' : ''}
                               link={customerRoutes.customer(lead.customerNumber)}/>
                    <FormInput label={t('leadform.type')} value={lead.companyType} readOnly={true}/>
                    <FormInput label={t('leadform.assignedto')} value={lead.assignee} clearButton={true} readOnly={true}/>
                    <FormInput label={t('leadform.product')} value={lead.productNumber} readOnly={true}/>
                    <FormInput label={t('leadform.submitted')} value={helpers.formatDate(lead.dateSubmitted)} readOnly={true}/>

                </div>

                <div>
                    <br/>
                    <button type="button" className="btn btn-default" onClick={onCloseClick}><span
                        className="vismaicon vismaicon-sm vismaicon-undo"></span>{t('leadform.close')}</button>
                </div>
                <LeadTrials lead={lead}/>
            </div>}
        </form>
    </>

}

export default LeadForm;